import httpClient from "../utils/httpClient";

export const stockSearch = async (payload) => {
    const response = await httpClient.post("/Jewellery/StockSearch", payload);
    return response.data;
};

export const stockSearchDetail = async (requestParams) => {
    const response = await httpClient.post('/Jewellery/StockSearchDetail', requestParams);
    return response.data;
};

export const QuickView = async (requestParams) => {
    const response = await httpClient.post('/Jewellery/GetQuickViewData', requestParams);
    return response.data;
};